import {
  definePointsLayer,
  defineBalloonManager,
  defineDrawPolygon,
  defineHotspotsLayer,
  definePopupManager,
} from './ymapsModules';

export async function loadYMapsApi(modules?: string[]): Promise<YMaps.IYMaps> {
  return new Promise((resolve, reject) => {
    window.ymapsLoaded(ymaps => {
      definePointsLayer(ymaps);
      defineBalloonManager(ymaps);
      defineDrawPolygon(ymaps);
      defineHotspotsLayer(ymaps);
      definePopupManager(ymaps);

      ymaps.ready({
        require: modules,
        successCallback: ymaps => resolve(ymaps),
        errorCallback: error => reject(error),
      });
    });
  });
}
